import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation createAutojoinDomainMutation($input: CreateAutojoinDomainInput!) {
		createAutojoinDomain(input: $input) {
			autojoinDomain {
				node {
					id
					name
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.companyId,
			connectionInfo: [
				{
					key: 'Company_autojoinDomains',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'autojoinDomain',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Autojoin Domain Created');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), name: input.name}},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
